import { useUser } from '../context/user'
import { Redirect } from 'react-router-dom'

const PrivateRoute = ({ Component }) => {
    const { isSignedIn } = useUser()
    return isSignedIn ? <Component /> : <Redirect to="/login" />
}

export default PrivateRoute
